module.exports = __webpack_public_path__ + "static/AppleStore-9990fca3c65392a38dec4861e80ac37f.svg";